import styled from 'styled-components';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;

  .sub-header {
    margin-left: auto;
  }

  .map-wrapper {
    width: 100%;
  }

  .map-container {
    width: 100%;
    height: 100%;
    border-radius: 12px 0 0 12px;
  }
  
  .widgets-container {
    display: flex;
    justify-content: space-between;
    background-color: ${(props) => props.theme.colors.widget_background};
    border-radius: 12px;
    margin-bottom: 24px;
    overflow: hidden;    

    .statistics-container {
      height: 632px;
      min-width: 380px;
      position: relative;

      &:has(.report-btn) {
        &:hover .report-btn {
          opacity: 0.8;
        }
      }

      .report-btn {
        position: absolute;
        top: 16px;
        right: 16px;
        border: none;
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        opacity: 0;
        transition: opacity 0.3s;
      }
    }
  }
  .fleet-config-status {
    position: absolute;
    top: 12px;
    right: 12px;
    display: inline-flex;
    align-items: center;
    cursor: default;
  }
  .fleet-config-main {
    position: relative;
    width: 100%;
  }
  .fleet-config-icon {
    display: inline-flex;
    alignItems: center;
  }
`;

export default { Wrapper };
